import {
  SIGNIN_FAILURE,
  SIGNIN_REQUEST,
  SIGNIN_SUCCESS,
  SIGNOUT_FAILURE,
  SIGNOUT_REQUEST,
  SIGNOUT_SUCCESS
} from './actionTypes'

export function signInRequest() {
  const [keycloak] = arguments
  return {
    type: SIGNIN_REQUEST,
    payload: { keycloak }
  }
}

export function signInSuccess() {
  const [keycloak] = arguments
  return {
    type: SIGNIN_SUCCESS,
    payload: { keycloak }
  }
}

export function signInFailure() {
  const [keycloak] = arguments
  return {
    type: SIGNIN_FAILURE,
    payload: { keycloak }
  }
}

export function signOutRequest() {
  return {
    type: SIGNOUT_REQUEST
  }
}

export function signOutSuccess() {
  return {
    type: SIGNOUT_SUCCESS
  }
}

export function signOutFailure() {
  return {
    type: SIGNOUT_FAILURE
  }
}
